export const padTwo = (num) => {
  return num.toString().padStart(2, '0');
};

export const formatDateMmDdYyyy = (date) => {
  if (!date) {
    return '';
  }
  const d = new Date(date);

  return [padTwo(d.getMonth() + 1), padTwo(d.getDate()), d.getFullYear()].join('/');
};



// WEBPACK FOOTER //
// ./src/utils/date-utils.js